export enum FilterValueTypeEnum {
  nonmissing = 'nonmissing',
  minmax = 'minmax',
  exactmatch = 'exactmatch',
  anymatch = 'anymatch',
  minmax_noyeardimension = 'minmax_noYearDimension',
  date = 'date'
}